<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <el-select
              class="select-default mb-3"
              style="width: 100%"
              @change="cleanSelect"
              v-model="filter_departments"
              filterable
              collapse-tags
              placeholder="Departamentos"
              multiple>
              <el-option
                class="select-default"
                v-for="item in departments"
                :key="item.CodeDpto"
                :label="item.NameDpto"
                :value="item.CodeDpto">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-select
              class="select-default mb-3"
              style="width: 100%"
              multiple
              filterable
              collapse-tags
              placeholder="Municipios"
              v-model="filter_municipalities">
              <el-option
                class="select-default"
                v-for="item in municipalities"
                :key="item.code"
                :label="item.name"
                :value="item.code">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-date-picker
              style="width: 100%;"
              :clearable="false"
              v-model="rangeDate"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="Fecha Inicial"
              end-placeholder="Fecha Final"
              align="center">
            </el-date-picker>
          </div>
          <div class="col-12 col-md-6 col-lg-3 text-center">
              <br class="c-none">
              <button type="button" class="btn btn-warning" @click="getFilteredData">Filtrar Datos</button>
          </div>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div v-if="canIndex()">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-6">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF()">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('instalaciones', tableData, tableColumnsAll, 1)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('instalaciones', tableData, tableColumnsAll, 1)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-3">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border
                      ref="tableModule"
                      :cell-class-name="trafficLightCell">
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
              <el-table-column
                label="Dias Pendientes"
                minWidth="120"
                prop="DiasPendienteMeta">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="text-right">
        <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportPDF('instalaciones', 'Instalaciones', 'a1', tableData, tableColumnsAll, 1)"><i class="fa fa-file-pdf-o"></i>
            Exportar a PDF
        </button>
      </div>
    </div>
    <div class="col-4">
      <div class="text-center">
        <button oncli class="btn btn-success btn-fg custom-shadow-btn" @click="exportExcel('instalaciones', tableData, tableColumnsAll, 1)"><i class="fa fa-file-excel-o"></i>
        Exportar a Excel
      </button>
      </div>
    </div>
    <div class="col-4">
      <div class="text-left">
        <button class="btn btn-info btn-fg custom-shadow-btn" @click="exportCSV('instalaciones', tableData, tableColumnsAll, 1)"><i class="fa fa-file-text-o"></i>
          Exportar a CSV
        </button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import showSwalAlert from 'src/util/alerts'
  import axios from 'axios'
  import moment from 'moment'
  import table from './instalationsTable'
  import swal from 'sweetalert2'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    data () {
      return {
        demandsForm: {},
        departments: [],
        municipalities: [],
        tableColumns: table[0],
        tableColumnsAll: table,
        isShow: true,
        rangeDate: [new Date((new Date().getFullYear()), (new Date().getMonth() - 1), 1), new Date((new Date().getFullYear()), 11 + 1, 0)]
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker],
    methods: {
      handleView (index, row) {
        this.isShow = true
        this.rowData = Object.assign({}, row)
        this.title = this.rowData.name
        this.modals['read'] = true
      },
      getFilteredData() {
        let self = this
        this.$emit('cotentLoading', true)

        let data = {}
        data.route ='instalations/index'
        data.filter_municipalities = (this.filter_municipalities.length == 0) ? '' : this.filter_municipalities.join()
        data.filter_departments = (this.filter_departments.length == 0) ? '' : this.filter_departments.join()
        data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD')
        data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD')

        this.saveMaster(data).then((response) => {
          this.tableData = response.data.instalations
          this.departments = response.data.departments
          this.municipalities = response.data.municipalities
          this.searchFuse(['Depart_Nombre', 'Region', 'Depart_Code', 'Municipio_Code', 'Municipio_Nombre', 'Direccion', 'IDPunto', 'Coordenadas', 'Estrato', 'Estado', 'Nombres', 'FechaGenera'])
          self.$emit('cotentLoading', false)
        }).catch((error) => {
          self.showMessageErrors(error)
          self.$emit('cotentLoading', false)
        })
      },
      trafficLightCell({row, column, rowIndex, columnIndex}) {
        if (columnIndex == 12) {
          if (row[column.property] >= 30) {
            return 'green-light'
          } else if (row[column.property] > 10 && row[column.property] < 30) {
            return 'yellow-light'
          } else if (row[column.property] > 0 && row[column.property] < 10) {
            return 'red-light'
          }else {
            return 'purple-light'
          }
        }
      },
      exportPDF() {
          let columns = []

          let tablecol = this.tableColumnsAll[0]
          tablecol = tablecol.concat(this.tableColumnsAll[1])

          tablecol.forEach(row => {
            columns.push({title: row.label, dataKey: row.prop})
          })

          showSwalAlert(
              'Espere mientras el archivo en formato PDF se descarga.',
              null, null, null, null, null, swal
          )

          setTimeout(() => {
              let doc = new jsPDF({orientation: "l", unit: "mm", format: 'a1'})
              doc.text('Instalaciones', 10, 10);
              doc.autoTable(columns, this.tableData, {
                margin: {top: 20},
                headStyles: {fillColor:'#FFA534'},
                didParseCell: function (HookData) {
                  if (HookData.row.index >= 0 && HookData.column.dataKey == 'DiasPendienteMeta'){
                    if (HookData.cell.raw != 'Dias Pendientes Meta') {
                      if (HookData.cell.raw > 30) {
                        HookData.cell.styles.fillColor = [0, 143, 57];
                        HookData.cell.styles.textColor = [255,255,255];
                      } else if (HookData.cell.raw >= 10 && HookData.cell.raw <= 30) {
                        HookData.cell.styles.fillColor = [255, 255, 0];
                      } else if (HookData.cell.raw >= 0 && HookData.cell.raw <= 10) {
                        HookData.cell.styles.fillColor = [255, 0, 0];
                        HookData.cell.styles.textColor = [255,255,255];
                      }else {
                        HookData.cell.styles.fillColor = [87, 35, 100];
                        HookData.cell.styles.textColor = [255,255,255];
                      }
                    }
                  }
                },
              })
              doc.save('instalaciones', {returnPromise: true}).then((res) => {
                  swal.close()
              })
              this.showDownloadNotification()
          }, 1000);
      },
      exportExcel(filename, datatable, table, plus=0){
        showSwalAlert(
            'Espere mientras el archivo en formato XLSX se descarga.',
            null, null, null, null, null, swal
        )

        let data = {}
        data.filter_municipalities = (this.filter_municipalities.length == 0) ? '' : this.filter_municipalities.join()
        data.filter_departments = (this.filter_departments.length == 0) ? '' : this.filter_departments.join()
        data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD')
        data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD')

        axios({
          url: '/auth/instalations/excel',
          method: 'post',
          data: data,
          responseType: 'blob',
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'instalaciones.xlsx');
          document.body.appendChild(link);
          link.click();
          swal.close()
        });
      },
    },
    created(){
      this.$emit('cotentLoading', true)
      if(this.canIndex()){
        this.getFilteredData()
      }
    },
  }
</script>
<style>
  .green-light {
    color: white;
    background-color: green;
  }
  .yellow-light {
    background-color: yellow;
  }
  .red-light {
    color: white;
    background-color: red;
  }
  .purple-light {
    color: white;
    background-color: purple;
  }
</style>
